import React from "react";
import { useTranslation } from "react-i18next";
import { RiCustomerService2Line, RiProductHuntLine } from "react-icons/ri";
import { TbTruckDelivery } from "react-icons/tb";

function Network() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <section className="networkSec sectionPD">
        <div className="container">
          <div className="networkItem">
            <div className="fisherman-content">
              <h3>{t("Our Network")} </h3>
            </div>
            <ul className="namedd">
              <li>
                <div className="networkNumber">
                  <RiCustomerService2Line />
                  <h2>+17K</h2>
                  <p>Vendors</p>
                </div>
              </li>
              <li>
                <div className="networkNumber">
                <RiProductHuntLine />

                  <h2>+50 M</h2>
                  <p>Products</p>
                </div>
              </li>
              <li>
                <div className="networkNumber">
                  <TbTruckDelivery />
                  <h2>+130  </h2>
                  <p>Countries</p>
                </div>
              </li>
              <li>
                <div className="networkNumber">
                  <TbTruckDelivery />
                  <h2>+1000  </h2>
                  <p>product categories</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default Network;
